module.exports = __webpack_public_path__ + "img/solution4.9b0b9c79.png";